<script setup lang="ts">
import { ref, computed } from 'vue';
import { useBodyScrollLock } from "@/composables/useBodyScrollLock";
import {useWindowSize} from "@vueuse/core";
import CustomButton from "@/components/Button/Button.vue";
import router from "@/router/router";
import {useBlogStore} from "@/stores/blogStore";
import PhoneItem from "@/components/PhoneItem/PhoneItem.vue";
import {useAboutStore} from "@/stores/aboutStore";



const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);
const closeDrawer = () => {
  emit('close');
};

const blogStore = useBlogStore();
const aboutStore = useAboutStore();
const isDrawerOpen = computed(() => props.isOpen);
useBodyScrollLock(isDrawerOpen);


const { width } = useWindowSize();
const isMobileSmall = computed(() => width.value <= 1336);


</script>


<template>
  <div v-if="props.isOpen && isMobileSmall"  class="fixed inset-0 bg-[rgba(0,0,0,0.5)] z-[9000] transition-opacity duration-300 ease-in-out" @click="closeDrawer"></div>
  <div v-if="isMobileSmall"
       :class="[
    'fixed top-0 right-0 h-full w-[350px] bg-white flex flex-col justify-between transition-transform duration-300 ease-in-out z-[9999] p-7.5 overflow-y-auto',
    props.isOpen ? 'translate-x-0' : 'translate-x-full',
    'sm:rounded-l-2xl'
  ]"
  >
    <div class="flex items-center justify-end px-2 bg-white">
      <div class="cursor-pointer border border-bw-grey py-1.5 px-4 rounded-full" type="default" @click="closeDrawer">
        <img src="@/assets/icons/Close_16x16.svg" alt="Close" width="16" />
      </div>
    </div>

    <div class="flex-1 overflow-y-auto text-primary-darkBlue pt-8">
      <ul class="space-y-6 responsive-title-5 font-semibold">
        <li>
          <RouterLink :to="`/yachts`" @click="closeDrawer">
            <span class="hover:text-primary-violet">Yachts</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="`/destinations`" @click="closeDrawer">
            <span class="hover:text-primary-violet">Destinations</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="`/magazine`" @click="closeDrawer">
            <span class="hover:text-primary-violet">Magazine</span>
          </RouterLink>
        </li>

        <li>
          <RouterLink :to="`/guide`" @click="closeDrawer">
            <span class="hover:text-primary-violet">Charter Guide</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="`/aboutUs`" @click="closeDrawer">
            <span class="hover:text-primary-violet">About us</span>
          </RouterLink>
        </li>
      </ul>
      <hr class="my-2.5"/>
      <div v-if="isMobileSmall" class="responsive-body-small mt-4">
        <CustomButton
            type="yellow"
            :shadow="false"
            size="medium"
            class="py-2 px-4"
            @click="() => { closeDrawer(); router.push('/inquiry') }"
        >
          INQUIRY
        </CustomButton>

      </div>
    </div>
    
    <!-- Phone Number + Email Section -->
    <hr class="my-2.5"/>

    <div class="flex flex-col gap-2 pt-3">
      <div class="flex items-start gap-2 text-primary-darkBlue responsive-body-medium ">
        <img src="@/assets/icons/phone.png" alt="Phone" class="h-6 w-6 flex-shrink-0 mt-1"/>
        <div class="flex flex-col gap-2">
          <div v-for="contact in aboutStore.contactInfo">
            <PhoneItem :contact="contact"/>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <img src="@/assets/icons/email.png" alt="Email" class="h-6 min-w-6"/>
        <div class="flex items-center gap-2 text-primary-darkBlue text-no-wrap responsive-body-medium">
          <a href="mailto:info@cosmosluxuryyachts.com" class="hover:underline">info@cosmosluxuryyachts.com</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
